<template>
<div id="scholarships" v-animate-onscroll="'animated fadeIn'">
    <h1>Awards, Scholarships and Supports</h1>
    
    <div class="scholarship_item" v-for="(record) in scholarships" :key="record.id">
        <span>
            <a :href="record.link" v-if="record.link">
                {{ record.item }} 
            </a>
            <span v-else>
                {{ record.item }}
            </span>
            <span v-if="record.earn">({{ record.earn }})</span>
        </span>
        <span style="right: 0;">
            {{ record.period }}
        </span>
    </div>

</div>
</template>

<script>
export default {
    name: 'Scholarship',
    data() {
        return {
            scholarships: [
                {
                    id: "vc",
                    item: "Li Po Chun Charitable Trust Fund Postgraduate Scholarship",
                    period: "2024/25",
                },
                {
                    id: "vc",
                    item: "Vice-Chancellor's PhD Scholarship",
                    period: "2024-2028",
                    link: "https://www.gs.cuhk.edu.hk/admissions/scholarships-fees/scholarships",
                },
                {
                    id: "asmpt",
                    item: "ASMPT Technology Silver Award 2024",
                    link: "https://www.cse.cuhk.edu.hk/news/achievements/ug-student-has-been-awarded-silver-award-from-the-asmpt-technology-competition-2024/",
                    period: "2024",
                },
                {
                    id: "visiting",
                    item: "Overseas Research Exchange Grants",
                    period: "2023/24",
                    link: "https://www.erg.cuhk.edu.hk/erg/ResearchExchangeScheme",
                    earn: "Up to HKD 50,000",
                },
                {
                    id: "elite",
                    item: "ELITE Stream Scholarship",
                    link: "https://www.erg.cuhk.edu.hk/erg/Elite/Scholarship",
                    period: "2023/24",
                },
                {
                    id: "woo",
                    item: "Woo Sau Wing Scholarship",
                    period: "2023/24",
                },
                {
                    id: "dean",
                    item: "Dean's List",
                    period: "2020/21, 2022/23, 2023/24",
                },
            ],
        }
    },
    methods: {
        getImageUrl(figname) {
            return require(`@/assets/img/${figname}`);
        },
    }
};
</script>

<style scoped>
#scholarships{
    position: relative;
    width: 1000px;
    margin: 0px auto;
    background-repeat: no-repeat;
    background-size: cover;
    color: #000000;
    font-family: "Comic Sans MS", "Comic Sans", "cursive";
}

.scholarship_item {
    width: 1000px;
    /* height: 50px; */
    line-height: 1.5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    padding: 0 20px;
    box-sizing: border-box;
    /* background-color: #f0f0f0; */
    border-radius: 5px;
}

.service_container {
    width: 1000px;
    height: 200px;
    display: flex;
    align-items: flex-start;
}

.service_icon {
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    box-sizing: border-box;
}
.service_icon img{
    max-width: 125px;
    max-height: 125px;
}
.service_description {
    height: 100%;
    width: 80%;
    padding: 0 20px;
    margin: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
</style>